import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class WorkshopEffect {
  constructor(private actions$: Actions) {}
}
